module.exports = "<div ui-view page-support class=\"override-global-spacing\"></div>";